<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoInserir">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoInserir">
            <form #form="ngForm" name="form" novalidate (ngSubmit)="salvar(form)">
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                        <div class="field col-12 md:col-5">
                            <label htmlFor="descricao">Descrição</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                type="text"
                                pInputText
                                placeholder="Descrição do serviço"
                                name="descricao"
                                ngModel
                                #descricao="ngModel"
                                required
                                [(ngModel)]="itemServico.descricao"
                            />
                            <div
                                *ngIf="descricao.hasError('required') && descricao.touched"
                                class="alerta"
                            >
                                <span>Campo obrigatório!</span>
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="subgrupo">Grupo</label>
                            <p-dropdown
                                [options]="subgrupos"
                                optionLabel="label"
                                [filter]="true"
                                optionValue="value"
                                emptyFilterMessage="Nenhum registro"
                                placeholder="Selecione"
                                name="subgrupo"
                                ngModel
                                #subgrupo="ngModel"
                                [required]="true"
                                [(ngModel)]="itemServico.subgrupo"
                            ></p-dropdown>
                            <div
                                *ngIf="subgrupo.hasError('required') && subgrupo.touched"
                                class="alerta"
                            >
                                <span>Por favor, selecione um valor.</span>
                            </div>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="codigo">Código</label>
                            <input
                                type="text"
                                pInputText
                                name="codigo"
                                oninput="this.value = this.value.toUpperCase();"
                                ngModel
                                #codigo="ngModel"
                                required
                                (blur)="verificarCodigoExistente(codigo.value)"
                                [(ngModel)]="itemServico.codigo"
                            />
                            <div
                                *ngIf="codigo.hasError('required') && codigo.touched"
                                class="alerta"
                            >
                                <span>Campo obrigatório!</span>
                            </div>
                            <div
                                *ngIf="!codigo.hasError('required') && codigoExistente"
                                class="alerta"
                            >
                                <span>Código já cadastrado!</span>
                            </div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="custoMaterial">Custo Material</label>
                            <p-inputNumber
                                suffix="%"
                                name="custoMaterial"
                                ngModel
                                #custoMaterial="ngModel"
                                [max]="100"
                                [minFractionDigits]="2"
                                [maxFractionDigits]="2"
                                [allowEmpty]="false"
                                [(ngModel)]="itemServico.custoMaterial"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="comissaoVenda">Comissão</label>
                            <p-inputNumber
                                suffix="%"
                                name="comissaoVenda"
                                ngModel
                                #comissaoVenda="ngModel"
                                [max]="100"
                                [minFractionDigits]="2"
                                [maxFractionDigits]="2"
                                [allowEmpty]="false"
                                [(ngModel)]="itemServico.comissaoVenda"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="valorVenda">Valor Médio</label>
                            <div class="flex flex-row">
                                <p-inputNumber
                                    name="valorVenda"
                                    ngModel
                                    #valorVenda="ngModel"
                                    mode="currency"
                                    inputId="currency-brazil"
                                    currency="BRL"
                                    locale="pt-BR"
                                    [allowEmpty]="false"
                                    [(ngModel)]="itemServico.valorVenda"
                                ></p-inputNumber>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Calcular precificação"
                                    (click)="abrirDialogValorSugerido()"
                                    icon="pi pi-percentage"
                                    class="p-button-success ml-2 w-4rem"
                                    type="button"
                                ></button>
                            </div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="tempoMedio">Tempo Médio</label>
                            <div class="flex">
                                <select
                                    class="form-control mr-1"
                                    [(ngModel)]="itemServico.tempoMedioHora"
                                    name="tempoMedioHora"
                                >
                                    <option *ngFor="let hora of horasServico" [value]="hora">
                                        {{ hora }}
                                    </option>
                                </select>

                                <select
                                    class="form-control"
                                    [(ngModel)]="itemServico.tempoMedioMinuto"
                                    name="tempoMedioMinuto"
                                >
                                    <option *ngFor="let minuto of minutosServico" [value]="minuto">
                                        {{ minuto }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label for="agenda">Agenda</label>
                            <p-dropdown
                                [options]="listaAgenda"
                                optionLabel="descricao"
                                optionValue="valor"
                                placeholder="Selecione"
                                name="agenda"
                                ngModel
                                #agenda="ngModel"
                                [required]="true"
                                [(ngModel)]="itemServico.agenda"
                            ></p-dropdown>
                            <div
                                *ngIf="agenda.hasError('required') && agenda.touched"
                                class="alerta"
                            >
                                <span>Por favor, selecione um valor.</span>
                            </div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label for="tributacao">Tributável</label>
                            <br />
                            <p-inputSwitch
                                name="tributacao"
                                ngModel
                                #tributacao="ngModel"
                                [(ngModel)]="itemServico.tributacao"
                            ></p-inputSwitch>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="col-12 md:col-4">
                            <button
                                *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                                type="submit"
                                pButton
                                icon="pi pi-check"
                                label="Salvar"
                                class="p-button-outlined p-button-success md:w-9rem"
                                [disabled]="!form.valid || codigoExistente"
                            ></button>
                            <ng-template #exibirBotaoFalso>
                                <button
                                    type="submit"
                                    pButton
                                    icon="pi pi-spin pi-spinner"
                                    label="Salvar"
                                    class="p-button-outlined p-button-success md:w-9rem"
                                    disabled
                                ></button>
                            </ng-template>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/item-servico"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-dialog
                [(visible)]="exibirDialogValorSugerido"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [style]="{ width: '35vw' }"
                [header]="'Sugestão de preço'"
                [modal]="true"
                [draggable]="false"
                [resizable]="false"
                class="p-fluid"
            >
                <ng-template pTemplate="content">
                    <div class="flex justify-content-center" *ngIf="loadingSpinnerDialog">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div class="formgrid grid" *ngIf="!loadingSpinnerDialog && itemServico">
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Custo Fixo</label>
                            <label class="label-inferior">
                                {{ custoMedio.custoFixo / 100 | percent: "1.2-2" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Custo Tributário</label>
                            <label class="label-inferior">
                                {{ custoMedio.imposto / 100 | percent: "1.2-2" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Custo Material</label>
                            <label class="label-inferior">
                                {{
                                    itemServico.custoMaterial
                                        ? (itemServico.custoMaterial / 100 | percent: "1.2-2")
                                        : "0,00%"
                                }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Comissão</label>
                            <label class="label-inferior">
                                {{
                                    itemServico.comissaoVenda
                                        ? (itemServico.comissaoVenda / 100 | percent: "1.2-2")
                                        : "0,00%"
                                }}
                            </label>
                        </div>

                        <div style="width: 100%">
                            <p-divider></p-divider>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="text-lg">Lucro Desejado</label>
                            <p-inputNumber
                                name="valorLucroDesejado"
                                ngModel
                                mode="currency"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                                [(ngModel)]="valorLucroDesejado"
                                (onInput)="calcularLucroDesejado($event)"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="text-lg">Valor Serviço</label>
                            <p-inputNumber
                                name="novoValorServico"
                                ngModel
                                mode="currency"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                                [(ngModel)]="novoValorServico"
                                (onInput)="calcularLucroObtido($event.value)"
                            ></p-inputNumber>
                        </div>

                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Valor Sugerido</label>
                            <label class="label-inferior">
                                {{ valorSugerido | currency: "BRL" }}
                            </label>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label class="label-superior text-lg">Lucro Obtido</label>
                            <label class="label-inferior" *ngIf="novoValorServico > 0">
                                <span
                                    class="product-badge bg-green-600 admihair-text-white"
                                    *ngIf="valorLucroObtido >= valorLucroDesejado"
                                >
                                    {{ valorLucroObtido | currency: "BRL" }}
                                </span>
                                <span
                                    class="product-badge bg-red-600 admihair-text-white"
                                    *ngIf="valorLucroObtido < valorLucroDesejado"
                                >
                                    {{ valorLucroObtido | currency: "BRL" }}
                                </span>
                            </label>
                            <label class="label-inferior" *ngIf="novoValorServico <= 0">
                                {{ valorLucroObtido | currency: "BRL" }}
                            </label>
                        </div>
                    </div>
                    <div class="flex justify-content-start mt-3" *ngIf="!loadingSpinnerDialog">
                        <button
                            pButton
                            pRipple
                            label="Confirmar"
                            icon="pi pi-check"
                            class="p-button-outlined w-full md:w-12rem"
                            (click)="confirmarValorServico()"
                            [disabled]="novoValorServico <= 0"
                        ></button>
                    </div>
                </ng-template>
            </p-dialog>
        </div>
    </div>
</div>
